import PubSub from "pubsub-js";
import Logger from "./Logger";

class EventPublisher {

    subscribe(topic, callback) {
        // Logger.debug("SUBSCRIBE: ", topic);
        return PubSub.subscribe(topic, callback);
    }

    unsubscribe(subscription) {
        Logger.debug("UNSUBSCRIBE: ", subscription);
        PubSub.unsubscribe(subscription);
    }

    publish(topic, content) {
        Logger.debug("PUBLISH", topic, content);
        if (PubSub.countSubscriptions(topic.toString()) < 1) {
            Logger.warn(
                "Publishing event: "+topic.toString()+" to 0 subscribers. Did you forget to register an Action/Store in App.js?");
        }
        PubSub.publish(topic, content);
    }

}

export default new EventPublisher();